import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import OrderV2ProductCard from './order-v2-product-card';

// ----------------------------------------------------------------------

OrderV2ProductSections.propTypes = {
  products: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  currency: PropTypes.string,
  onOpenProduct: PropTypes.func.isRequired,
};

export default function OrderV2ProductSections({ products, categories, currency, onOpenProduct }) {
  return (
    <>
      {categories.map((c) => {
        const items = products
          .filter((p) => p.type === c.name)
          .sort((a, b) => {
            if (a.menu_sort_order > b.menu_sort_order) return 1;
            if (a.menu_sort_order < b.menu_sort_order) return -1;
            return 0;
          });

        if (items.length === 0) {
          return null;
        }

        return (
          <Box
            key={c.id}
            component="section"
            id={`cat${c.id}`}
            sx={{
              mb: 6,
              scrollMarginTop: { xs: 120, md: 140 },
            }}
          >
            <Typography
              component="h2"
              sx={{
                fontSize: { xs: 22, sm: 24 },
                fontWeight: 800,
                letterSpacing: '-0.03em',
                lineHeight: 1.2,
                color: '#1d1d1f',
                mb: { xs: 2.5, md: 3 },
              }}
            >
              {c.name}
            </Typography>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'minmax(0, 1fr)',
                  sm: 'repeat(2, minmax(0, 1fr))',
                  md: 'repeat(4, minmax(0, 1fr))',
                },
                gap: { xs: 2, sm: 2.25, md: '28px' },
                alignItems: 'stretch',
              }}
            >
              {items.map((p) => (
                <Box key={p.id} sx={{ minWidth: 0, height: '100%', display: 'flex' }}>
                  <OrderV2ProductCard product={p} currency={currency} onOpen={onOpenProduct} />
                </Box>
              ))}
            </Box>
          </Box>
        );
      })}
    </>
  );
}
